const hbs = require("handlebars/runtime");

// Templates
hbs.templates = hbs.templates || {};

// LawyerSearch
hbs.templates.lawyerSearch = hbs.templates.lawyerSearch || {};
if (typeof templateVersion !== 'undefined') {
    hbs.templates.lawyerSearch.resultListEntry = require("../../templates/lawyerSearch/resultListEntry" + templateVersion + ".hbs");
    hbs.templates.lawyerSearch.mapsInfoBox = require("../../templates/lawyerSearch/mapsInfoBox"+ templateVersion +".hbs");
}
// AgentSearch
hbs.templates.agentSearch = hbs.templates.agentSearch || {};
hbs.templates.agentSearch.resultListEntry = require("../../templates/agentSearch/resultListEntry.hbs");
hbs.templates.agentSearch.mapsInfoBox = require("../../templates/agentSearch/mapsInfoBox.hbs");

// AgencySearch
hbs.templates.agencySearch = hbs.templates.agencySearch || {};
hbs.templates.agencySearch.resultListEntry = require("../../templates/agencySearch/resultListEntry.hbs");
hbs.templates.agencySearch.mapsInfoBox = require("../../templates/agencySearch/mapsInfoBox.hbs");

// LocationMap
hbs.templates.locationMap = hbs.templates.locationMap || {};
hbs.templates.locationMap.mapsInfoBox = require("../../templates/locationMap/mapsInfoBox.hbs");
hbs.templates.locationMap.mapsInfoBox2 = require("../../templates/locationMap/mapsInfoBox2.hbs");

// ProcessCostsCalculator
hbs.templates.processCostsCalculator = require("../../templates/processCostsCalculator.hbs");

// FineCalculator
hbs.templates.fineCalculator = require("../../templates/fineCalculator.hbs");

// FlightCompensationCalculator
hbs.templates.flightCompensationCalculator = require("../../templates/flightCompensationCalculator.hbs");

module.exports = hbs;
